export default class Layer {
    constructor() {

        this.id = null;

        this.name = null;
        this.sourceIndex = null;

        this.mapSourceName = '';    // mapbox.addSource unique name
        this.mapLayerName = '';     // mapbox.addLayer unique name
        this.mapClusterLayerName = '';
        this.mapClusterTextLayerName = '';
        this.mapContourLayerName = '';

        this.visible = true;
        this.typeIndex = 0; // index of layerTypeParams
        this.expanded = false;

        this.exposeTick = false;

        this.popupTitle = 'Title'
        this.popupHTML = 'Content'
        
        

        this.layerTypeParams = [
            {
                name : 'points',
                params : {
                    radius : 8,
                    extrudeHeight: 0,
                    shape : 'circle', // circle / square / hexagon
                    icon: null,
                    underBuildings : false,
                    mapAligned : false,
                    clustered : false,
                    clusterRadius: 50, 
                    clusterCircleRadius: 16, 
                    clusterMaxZoom : 14,
                    appearance: {
                        background : {
                            color : {
                                r: 69,
                                g: 111,
                                b: 145,
                                a: 1
                            },
                            opacity : 1
                        },
                        stroke : {
                            width: 2,
                            color : {
                                r: 255,
                                g: 255,
                                b: 255,
                                a: 1
                            },
                            opacity : 0.8
                        },
                        clustered : {
                            background : {
                                color : {
                                    r: 32,
                                    g: 156,
                                    b: 193,
                                    a:1,
                                },
                                opacity : 1
                            },
                            stroke : {
                                width: 5,
                                color : {
                                    r: 255,
                                    g: 255,
                                    b: 255,
                                    a: 1
                                },
                                opacity : 0.66
                            },
                            text: {
                                size: 11,
                                color : {
                                    r: 255,
                                    g: 255,
                                    b: 255,
                                    a: 1
                                },
                                opacity : 1
                            }
                        }
                    }
                }
            },
            {
                name : 'zones',
                params : {
                    underBuildings : false,
                    extrudeHeight: 10,
                    extrudeHeightBase: 0,
                    appearance: {
                        background : {
                            color : {
                                r: 69,
                                g: 112,
                                b: 145,
                                a: 1
                            },
                            opacity : 0.6
                        },
                        stroke : {
                            width: 2,
                            gapWidth: 0,
                            color : {
                                r: 10,
                                g: 10,
                                b: 10,
                                a: 1
                            },
                            opacity : 1,
                            blur: 0
                        }
                    }
                }
            },
            {
                name : 'lines',
                params : {
                    underBuildings : true,
                    extrudeHeight: 0,
                    appearance: {
                        stroke : {
                            width: 1.5,
                            gapWidth: 0,
                            color : {
                                r: 0,
                                g: 0,
                                b: 0,
                                a: 1
                            },
                            opacity : 0.2,
                            blur: 0.1,

                        }
                    }
                }
            },
            {
                name : 'heatmap',
                params : {
                    underBuildings : false,
                    type : 'smooth', // smooth / hexa
                    margin : 0,
                    height: 0,
                    radius : 25, // radius of influence of each points to the heatmap,
                    weight : 1, // how much individual point contribute. (weight = 2 ==> the point count as 2 points)
                    intensity: 1, // multiplier of weight
                    appearance: {
                        color : {
                            r: 255,
                            g: 0,
                            b: 0,
                            a: 1
                        },
                        opacity : 0.6,
                    }
                }
            }
        ]

        this.layerTypeParamsMapbox = [
            {
                name : 'points',
                params : {
                    radius : { name: 'circle-radius', fc: 'setPaintProperty', layer: 'main', type: 'float'},
                    extrudeHeight: 0,
                    shape : 'circle', // circle / square / hexagon
                    icon: null,
                    underBuildings : false,
                    mapAligned : { name: 'circle-pitch-alignment', fc: 'setPaintProperty', layer: 'all', type: 'float'},
                    clustered : true,
                    clusterRadius: 50, 
                    clusterCircleRadius: { name: 'circle-radius', fc: 'setPaintProperty', layer: 'cluster', type: 'float'}, 
                    clusterMaxZoom : 14,
                    appearance: {
                        background : {
                            color : { name: 'circle-color', fc: 'setPaintProperty', layer: 'main', type: 'color'},
                            opacity : { name: 'circle-opacity', fc: 'setPaintProperty', layer: 'main', type: 'float'}
                        },
                        stroke : {
                            width: { name: 'circle-stroke-width', fc: 'setPaintProperty', layer: 'main', type: 'float'},
                            color : { name: 'circle-stroke-color', fc: 'setPaintProperty', layer: 'main', type: 'color'},
                            opacity : { name: 'circle-stroke-opacity', fc: 'setPaintProperty', layer: 'main', type: 'float'}
                        },
                        clustered : {
                            background : {
                                color : { name: 'circle-color', fc: 'setPaintProperty', layer: 'cluster', type: 'color'},
                                opacity : { name: 'circle-opacity', fc: 'setPaintProperty', layer: 'cluster', type: 'float'}
                            },
                            stroke : {
                                width: { name: 'circle-stroke-width', fc: 'setPaintProperty', layer: 'cluster', type: 'float'},
                                color : { name: 'circle-stroke-color', fc: 'setPaintProperty', layer: 'cluster', type: 'color'},
                                opacity : { name: 'circle-stroke-opacity', fc: 'setPaintProperty', layer: 'cluster', type: 'float'}
                            },
                            text: {
                                size: { name: 'text-size', fc: 'setLayoutProperty', layer: 'cluster_text', type: 'float'},
                                color : { name: 'text-color', fc: 'setPaintProperty', layer: 'cluster_text', type: 'color'},
                                opacity : { name: 'text-opacity', fc: 'setLayoutProperty', layer: 'cluster_text', type: 'float'}
                            }
                        }
                    }
                }
            },
            {
                name : 'zones',
                params : {
                    underBuildings : false,
                    extrudeHeight: { name: 'fill-extrusion-height', fc: 'setPaintProperty', layer: 'main', type: 'float'},
                    extrudeHeightBase: { name: 'fill-extrusion-base', fc: 'setPaintProperty', layer: 'main', type: 'float'},
                    appearance: {
                        background : {
                            color : { name: 'fill-extrusion-color', fc: 'setPaintProperty', layer: 'main', type: 'color'},
                            opacity : { name: 'fill-extrusion-opacity', fc: 'setPaintProperty', layer: 'main', type: 'float'}
                        },
                        stroke : {
                            width: { name: 'line-width', fc: 'setPaintProperty', layer: 'contour', type: 'float'},
                            gapWidth: { name: 'line-gap-width', fc: 'setPaintProperty', layer: 'contour', type: 'float'},
                            color : { name: 'line-gradient', fc: 'setPaintProperty', layer: 'contour', type: 'color'},
                            opacity : { name: 'line-opacity', fc: 'setPaintProperty', layer: 'contour', type: 'float'},
                            blur: { name: 'line-blur', fc: 'setPaintProperty', layer: 'contour', type: 'float'}
                        }
                    }
                }
            },
            {
                name : 'lines',
                params : {
                    underBuildings : false,
                    extrudeHeight: 0,
                    appearance: {
                        stroke : {
                            width: { name: 'line-width', fc: 'setPaintProperty', layer: 'main', type: 'float'},
                            gapWidth: { name: 'line-gap-width', fc: 'setPaintProperty', layer: 'main', type: 'float'},
                            color : { name: 'line-gradient', fc: 'setPaintProperty', layer: 'main', type: 'color'},
                            opacity : { name: 'line-opacity', fc: 'setPaintProperty', layer: 'main', type: 'float'},
                            blur: { name: 'line-blur', fc: 'setPaintProperty', layer: 'main', type: 'float'}
                        }
                    }
                }
            },
            {
                name : 'heatmap',
                params : {
                    underBuildings : false,
                    type : 'smooth', // smooth / hexa
                    margin : 0,
                    height: 0,
                    radius : { name: 'heatmap-radius', fc: 'setPaintProperty', layer: 'main', type: 'float'}, // radius of influence of each points to the heatmap,
                    weight : { name: 'heatmap-weight', fc: 'setPaintProperty', layer: 'main', type: 'float'}, // how much individual point contribute. (weight = 2 ==> the point count as 2 points)
                    intensity: { name: 'heatmap-intensity', fc: 'setPaintProperty', layer: 'main', type: 'float'}, // multiplier of weight
                    appearance: {
                        color : { name: 'heatmap-color', fc: 'setPaintProperty', layer: 'main', type: 'color'},
                        opacity : { name: 'heatmap-opacity', fc: 'setPaintProperty', layer: 'main', type: 'float'},
                    }
                }
            }
        ]
        
    }

    init() {

    }
}